<template>
    <div class="py-2">
        <label for="{{forLabel}}" class="block text-sm font-medium text-gray-700"><span v-if="required" class="text-rose-600">*</span> {{label}}</label>
        <div class="mt-1">
                <div class="flex flex-col w-full" >

                    <div class="text-xs py-1">{{ searchlabel }}</div>

                    <div class="relative">

                        <div class="relative">
                            <input type="text" id="search" name="search" minlength="4" maxlength="30" placeholder="Pesquisar | nome " class="defaultInput pl-10 pr-10" v-model="params.search" @input="getProducts">
                            <MagnifyingGlassIcon class="h-6 w-6 absolute top-2 left-2 text-gray-600" />
                            <XMarkIcon v-if="params.search" @click="cleanAll"  class="h-6 w-6 absolute top-2 right-2 text-gray-600" />
                        </div>

                        <!-- Products list -->
                        <div v-if="listProducts.products.length > 0" class="pt-2 ">
                            <div v-for="(product,productIndex) in listProducts.products" :key="productIndex" class="relative mb-2 p-2 border-2 rounded hover:border-indigo-600 w-full">

                                <div class="absolute top-2 right-2">
                                    <XMarkIcon class="h-4 w-4 text-gray-600 cursor-pointer" @click="removeProduct(productIndex)" />
                                </div>

                                <div class="flex items-center text-sm bg-white">
                                    <div class="h-22 w-22 flex items-center justity-center pr-2 shrink-0">
                                        <img :src="product.image || '/imgs/product.png'" class="h-16 w-16">
                                    </div>
                                    <div>
                                        <div class="font-semibold text-xs">{{ product.code }} - {{ product.name }}</div>
                                    </div>
                                </div>
                                <div v-for="(field,fieldIndex) in product.fields" :key="fieldIndex" class="mt-2">
                                    <div  v-if="field?.type == 'input'"  class="flex items-center px-2">
                                        <div class="w-full">                                
                                            <InputText :label="field.label" :value="field.value" v-model="field.value" />
                                        </div>                            
                                    </div>
                                    <div v-if="field?.type == 'select'" class="text-sm px-2 py-1 flex flex-col">
                                        {{ field.label }}
                                        <select class="defaultInput" v-model="field.value">
                                            <option v-for="(option, index) in field.options" :key="index" >
                                                {{ option.name }}
                                            </option>               
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Dropdown search -->
                        <div v-if="searchProducts.length > 0" class=" bg-gray-50 absolute top-10 left-0 right-0 max-h-[250px] overflow-auto rounded-b-lg shadow-xl border-2 border-gray-200 z-10">
                            <div v-for="product in searchProducts" :key="product.id" class="p-1">
                                <div @click="addProduct(product)" class="flex gap-2 items-center border-2 border-transparent rounded-lg text-sm bg-white hover:border-indigo-600 cursor-pointer p-1">
                                    <div class="h-16 w-16 flex items-center justity-center">
                                        <img :src="product.image || '/imgs/product.png'" class="h-16 w-16">
                                    </div>
                                    <div>
                                        <div class="font-bold">{{ product.code }} - {{ product.name }}</div>
                                        <div class="text-xs">{{ limit(product.description) }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    
                </div>

        </div>
    </div>
    
  </template>
  
  <script>

import { XMarkIcon, MagnifyingGlassIcon } from '@heroicons/vue/24/solid';

  
  export default {
      name: 'Produtos',
      props: {
        value: {
            type: Object,
            required: false,
        },

        name: {
            type: String,
            required: false,
        },

        field_id: {
            type: [String, Number],
            required: false,
        },

        label: {
            type: String,
            required: false,
        },       

        reasonLabel: {
            type: String,
            required: false,
        },

        searchlabel: {
            type: String,
            required: false,
        },

        required: {
            type: Boolean,
            required: false,
            default: false,
        }, 

        settings_workspaces_id: {
            type: String,
            required: false,
        },

        root_owners_id: {
            type: String,
            required: true,
        },

        fieldsError: {
            type: Object,
            required: false,
        },

        fields: {
            type: Object,
            required: true,
        },            

      },
  
      data() {
          return {
            urlDefault: 'api/components/products',
            
            params: {
                settings_workspaces_id: this.settings_workspaces_id,
                root_owners_id:  this.root_owners_id,
                search: '',
            },
            errorClass: '',

            searchProducts: [],

            listProducts: {
              id: this.field_id,
              label: this.label,
              name: this.name,
              products: [],
            }
          }
      },
  
      methods: {

        limit(text) {
            if(text.length > 50) {
                return text.substring(0, 50) + '...';
            }
            return text;
        },

        cleanAll() {
            this.params.search = '';
            this.searchProducts = [];
        },

        async getProducts() {
            if(this.params.search.length < 4) {this.searchProducts = [];  return;}
            const response = await this.$ApiService.get(this.urlDefault, this.params)

            // remove da lista os produtos que já estão adicionados
            const products = response.data.filter(item => {
                const index = this.listProducts.products.findIndex(product => product.product_id === item.product_id);
                if(index >= 0) {return false;}
                return true;
            });

            this.searchProducts = products;
        },

             

        addProduct(product) {
            this.cleanAll();

            // verifica se o produto existe na lista
            const index = this.listProducts.products.findIndex(item => item.product_id === product.product_id);
            if(index >= 0) {return;}
            
            // adiciona as opções personalizadas ao produto
            product.fields = JSON.parse(JSON.stringify(this.fields));
            this.listProducts.products.push(product);
        },

        removeProduct(index) {
            this.listProducts.products.splice(index, 1);

        },
      },
      
      watch: {
        listProducts: {
          handler: function (val, oldVal) {
            this.$emit('update:modelValue', this.listProducts);
          },
          deep: true,
        },
                      
      },
     
      created() {
        if (this.value) {
          this.listProducts.products = this.value;
        }
        

        // aguarda 500ms
        setTimeout(() => {

          //this.$emit('update:modelValue', this.listProducts);
          //this.params.root_owners_id = this.user.root_owners_id;
        }, 100);
        
      },

        components: {
            XMarkIcon,
            MagnifyingGlassIcon,
        },

  }
  </script>